import React, { useEffect, useState } from 'react';
import {
  Product,
  ProductDesign,
  ProductInfoComponent,
  ProductType
} from '@inter-ikea-storageone/range';
import { getProductsForGroup } from 'ducks/products';
import { useSelector } from 'react-redux';
import { useCore } from 'contexts/core';
import { Entity } from '@inter-ikea-core/core';
import { getProductEntities } from 'ducks/core';
import { getSelectedRange } from 'ducks/range';
import { getFramesInScene } from 'rangeConfig/shared/utils/colorUtils/utils';
import { useAppDispatch } from 'ducks/hooks';
import { showInfoMessage } from 'ducks/layout';
import ChangeColor from 'components/ProductSidebar/menus/Widgets/ChangeColor/ChangeColor';
import { changeSolutionColor } from 'rangeConfig/billy/utils/changeSolutionColor';
import * as R from 'ramda';
import { sortColors } from 'products';

const getProductDesigns = (products: Product[]) => {
  const designs = products.map(product => product.design);
  return R.uniq(designs);
};

const ChangeFramesColor = () => {
  const coreApi = useCore();
  const dispatch = useAppDispatch();
  const productsInGroup = useSelector(getProductsForGroup);
  const designsInGroup = getProductDesigns(productsInGroup) as ProductDesign[];
  const productEntities = useSelector(getProductEntities);
  const range = useSelector(getSelectedRange);
  const [frameEntities, setFrameEntities] = useState<Entity[]>([]);
  const sortedDesignsInGroup = sortColors(designsInGroup);

  useEffect(() => {
    setFrameEntities(
      getFramesInScene(coreApi, range).filter(
        f =>
          f?.getComponent<ProductInfoComponent>(ProductInfoComponent.id)?.productType !==
          ProductType.BILLY_FRAME_EXTENSION
      )
    );
  }, [coreApi, productEntities, range]);

  const onChangeColor = (design: ProductDesign) => {
    const notReplaceableFrameFound = changeSolutionColor(
      coreApi,
      frameEntities,
      design,
      productsInGroup
    );
    if (notReplaceableFrameFound) {
      dispatch(showInfoMessage({ message: 'storageone.changeColorSomeMissingFramesMessage' }));
    }
  };

  return designsInGroup.length > 1 ? (
    <ChangeColor
      entities={frameEntities}
      onChangeColor={onChangeColor}
      defaultColor={sortedDesignsInGroup[0]}
    />
  ) : (
    <></>
  );
};

export default ChangeFramesColor;
